import {
  getAuthenticationUrl,
  getAuthenticationToken,
  TAuthProvider,
  PROVIDERS as AUTH_PROVIDERS
} from "./auth";
import {
  createScene,
  deleteScene,
  getSignedUrl,
  ingest,
  uploadFile,
  getScenes,
  getScene,
  getScenePreview,
  GetScenesQuery
} from "./scenes";
import { getModels } from "./models";
import {
  getInferences,
  GetInferencesQuery,
  validate,
  invalidate,
  getSceneInferences
} from "./inferences";

export default {
  getAuthenticationUrl,
  getAuthenticationToken,
  getInferences,
  getSceneInferences,
  getScenes,
  getScene,
  getScenePreview,
  AUTH_PROVIDERS,
  getModels,
  createScene,
  deleteScene,
  getSignedUrl,
  ingest,
  uploadFile,
  validateInference: validate,
  invalidateInference: invalidate
};

export type {
  TAuthProvider,
  GetInferencesQuery,
  GetScenesQuery,
};
